import { BillStatusType } from "@/types/contracts";
import { ReactNode } from "react";
import { twMerge } from "tailwind-merge";

type Props = {
  status: BillStatusType;
  children?: ReactNode;
};

type StatusBadgeType = "success" | "warning" | "error" | "default";

const getContractBillStatusType = (status: BillStatusType): StatusBadgeType => {
  switch (status) {
    case "CANCELED":
    case "DELETED":
    case "OVERDUE":
    case "EXPIRED":
      return "error";
    case "PAID":
      return "success";
    case "PENDING":
      return "warning";
    default:
      return "default";
  }
};

const ContractBillStatusBadge = ({ status, children }: Props) => {
  const type = getContractBillStatusType(status);
  return (
    <span className="row-left gap-1 capitalize">
      <span
        className={twMerge(
          "mr-1 h-1.5 w-1.5 rounded",
          type === "warning" && "bg-orange-500",
          type === "error" && "bg-destructive",
          type === "success" && "bg-green-500",
          type === "default" && "bg-muted",
        )}
      />
      {status.toLowerCase()}
      {children}
    </span>
  );
};

export default ContractBillStatusBadge;
